<template>
  <div>
    <v-card flat>
      <v-card-text class="py-0">
        <v-divider />
        <base-table-header
          :btnAdd="$allow('psp-peserta-kp-lokakarya.create')"
          @add="onAdd"
          @reload="onReload"
          @search="onSearch"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah Data <span class="blue--text font-weight-medium">{{ total }}</span>
            </div>
          </template>
        </base-table-header>
        <v-divider />
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row no-gutters>
                    <v-col cols="12" md="4">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="blue">
                          <v-icon dark>mdi-google-classroom</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <p class="caption grey--text">
                            Nama Kelompok KP
                          </p>
                          <span class="body-1"> {{ $getDeepObj(item, 'nama') || '-' }} </span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Nama Kegiatan </small></v-label>
                          </v-list-item-title>
                          <div class="link black--text body-2">
                            {{ $getDeepObj(item, 'm_lokakarya_kegiatan_psp.keterangan') || '-' }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small> Status </small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-chip dark :color="Number(item.is_lengkap) === 1 ? 'success' : 'orange'">
                              {{ Number(item.is_lengkap) === 1 ? 'Sudah Lengkap' : 'Belum Lengkap' }}
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Aksi</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <template v-if="false">
                              <div>
                                <v-btn small color="primary">
                                  <v-icon left>mdi-account-group</v-icon>
                                  Penugasan
                                </v-btn>
                              </div>
                              <div class="my-1">
                                <v-btn small color="primary">
                                  <v-icon left>mdi-file</v-icon>
                                  Laporan PA
                                </v-btn>
                              </div>
                            </template>
                            <div>
                              <v-btn small color="primary" @click="onEdit(item)">
                                <v-icon left>{{
                                  Number($getDeepObj(item, 'psp_kp_lokakarya_pas.0.is_pelapor')) === 1
                                    ? Number($getDeepObj(item, 'is_lengkap')) === 1
                                      ? 'mdi-eye'
                                      : 'mdi-pencil'
                                    : 'mdi-eye'
                                }}</v-icon>
                                {{
                                  Number($getDeepObj(item, 'psp_kp_lokakarya_pas.0.is_pelapor')) === 1
                                    ? Number($getDeepObj(item, 'is_lengkap')) === 1
                                      ? 'Lihat Detail'
                                      : 'Lengkapi'
                                    : 'Lihat Detail'
                                }}
                              </v-btn>
                            </div>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full ref="modal" :useSave="formulir.useSave" :title="formulir.title" @save="onSave">
      <component
        ref="formulir"
        :is="formulir.form"
        :initValue="formulir.init"
        :isEdit="formulir.isEdit"
        :readOnly="formulir.readOnly"
        :masters="masters"
        :detail="formulir.detail"
        @refresh="onEdit"
      />
    </base-modal-full>
  </div>
</template>

<script>
import list from '@mixins/list';
import mixin from '../mixin';
import FormKelompok from '../components/Form';
import { mapState } from 'vuex';
export default {
  components: { FormKelompok },
  mixins: [list, mixin],
  data() {
    return {
      endpoint: 'kp-lokakarya',
      formulir: {},
    };
  },
  computed: {
    ...mapState('master', ['masters']),
  },
};
</script>

<style scoped></style>
